import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { clearPlayerTurnover } from '../../services'
import {
	ClearPlayerTurnoverRequest,
	ClearPlayerTurnoverResponse,
} from '../../../type'

export default function useMutationClearPlayerTurnover(
	props?: UseBaseMutationOptions<
		ClearPlayerTurnoverResponse,
		ClearPlayerTurnoverRequest
	>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.ClearPlayerTurnover],
		mutationFn: (payload) => clearPlayerTurnover(payload),
		...props,
	})
}
